// extracted by mini-css-extract-plugin
module.exports = {"container":"TextArea_container__3r3My","title":"TextArea_title__1uyJO","customInput":"TextArea_customInput__38z_J"};